import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box } from "@mui/material"
import Chat from "../../Chat/Chat"
import ModalCloseButton from "../ModalCloseButton"

const ChatModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <>
          <ModalCloseButton handleClose={handleClose} />
          <Chat to={props.skill?.user_name} skill_name={props.skill?.name} />
        </>
      </Modal>
    </div>
  )
})

export default ChatModal
